import { Title } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { downloadJointCertificateProgram } from '@/components/tax-refund/common/utils/downloadJointCertificateProgram';
import IndisProgramDownloadCompleteGuide from '@/components/tax-refund/individual/JointCertificate/install/IndisProgramDownloadCompleteGuide';
import IndisProgramDownloadGuide from '@/components/tax-refund/individual/JointCertificate/install/IndisProgramDownloadGuide';
import IndisProgramInstallGuideDialog from '@/components/tax-refund/individual/JointCertificate/install/IndisProgramInstallGuideDialog';
import { INDIVIDUAL_PATHS } from '@/lib/constants/paths';
import { checkJoinCertificateServer } from '@/lib/utils/joint-certificate';

const IndisInstallJointCertificateContent = () => {
  const router = useRouter();
  const [downloadClicked, setDownloadClicked] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        await checkJoinCertificateServer();
        router.replace({
          pathname: `${INDIVIDUAL_PATHS.개인공동인증서선택}`,
          query: router.query
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const downloadFile = () => {
    downloadJointCertificateProgram();

    setDownloadClicked(true);
  };

  const handleClick = async () => {
    try {
      await checkJoinCertificateServer();
      router.replace({
        pathname: `${INDIVIDUAL_PATHS.개인공동인증서선택}`,
        query: router.query
      });
    } catch (error) {
      setOpenDialog(true);
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <div className="page-padding flex w-full flex-col">
      <Title.Headline size="large" title={'공동인증서를 불러오기 위해\n필수 프로그램을 설치해주세요'} />
      <div className="pb-[80px]" />
      {downloadClicked ? (
        <IndisProgramDownloadCompleteGuide handleDownload={downloadFile} handleClick={handleClick} />
      ) : (
        <IndisProgramDownloadGuide handleDownload={downloadFile} />
      )}
      <IndisProgramInstallGuideDialog isOpen={openDialog} handleClose={handleClose} />
    </div>
  );
};

export default IndisInstallJointCertificateContent;
